import { EventType, Features, SourcePages } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

export type FooterAction =
  | 'language'
  | 'contact'
  | 'login'
  | 'see_all_cities'
  | 'see_all_models'
  | 'see_all_categories'
  | 'terms_of_use'
  | 'privacy_policy'
  | 'ccpa'
  | 'about'
  | 'careers'
  | 'engineering'
  | 'our_team'
  | 'news_and_analysis'
  | 'guides_and_reviews'
  | 'fb'
  | 'twitter'
  | 'pinterest'
  | 'instagram'
  | 'rss'
  | 'app_store'
  | 'google_play';

interface FooterTapEventInfo {
  action: FooterAction;
  pathName: SourcePages;
}

function event({ action, pathName }: FooterTapEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: pathName,
    feature: Features.footerNav,
    engagement_type: `${action}_tap`,
  };
}

export default event;
